
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers",
      function () {
        return require("private-next-pages/customers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers"])
      });
    }
  